import React, {Component} from 'react';
import vuepay_large_logo from '../../assets/images/vuepaylogonav@5x.png';
import {hideModal} from "../../util/utility";
import strings from "../../util/strings";
import assets from "../../util/assets";

export default class YotiModal extends Component {

    closeModal = () => {
        document.getElementsByClassName("modal-overlay")[0].style.display = "none";
        const modal = document.getElementById("common-modal");
        hideModal(modal);
        this.props.updateType && this.props.updateBroadcastType();
        this.props.navCreateBroadcast();
    }

    render() {
        
        return (
            <div id="common-modal"
                className="modal fade guest"
                role="dialog"
                aria-labelledby="myModalLabel"
                aria-hidden="true">

                <div className="vertical-alignment-helper">
                    <div className="login-container">
                        <div className="modal-content">
                            <div className="popup-header" style={{right: '1%'}}>
                                <button type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        onClick={this.closeModal}
                                >
                                    <img alt={"close-icon"}
                                        src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"} />
                                </button>

                            </div>
                            <div className="modal-body">
                                <div className="row" id="yotiContainer">
                                    <div className="col-md-6 bg-primary d-flex align-items-center text-center"
                                        style={{ borderRight: '1px solid #e7e7e7' }} id="yotiLogo">
                                        <img src={vuepay_large_logo} className="img-fluid" alt={"VuePay logo"} />
                                    </div>
                                    <div className="col-md-6 bg-white d-flex align-items-center" id="yotiDescision">
                                        <div className="login-content">
                                            {/*<h4 style={{ color: '#58595B' }}>{this.props.isCreateProfile ? "Thanks for requsting to become a broadcaster" : "Your account is in pending state."}</h4>*/}
                                            <p style={{
                                                color: '#58595B',
                                                textAlign: 'left'
                                            }}>{this.props.isCreateProfile ? strings.yoti.after_create_profile : strings.yoti.unverified_access}</p>
                                            <div className="text-center" style={{marginTop: 50}}>
                                                <button className="btn btn-primary"
                                                        onClick={() => this.props.callYotiIntegration()}
                                                        style={{minWidth: 215}}>
                                                    {
                                                        this.props.yotiModalStatus ?
                                                            <img src={assets.loading_white} width={25} height={25} alt={"loading..."}/>
                                                            :
                                                            "Confirm"
                                                    }
                                                </button>
                                                <button className="btn btn-outline-primary signup"
                                                        onClick={this.closeModal} style={{minWidth: 215}}>
                                                    Skip
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="row" id="yoti" style="display:none">
                                    <iframe id="yotiFrame" src="#"/>
                                </div> */}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}